<template>
  <section class="height-100-p">
    <el-table
      ref="searchSummaryBillOfLadingTable"
      :data="billOfLading.list"
      v-loading="billOfLading.loadingSearch"
      id="bill-of-lading-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      stripe
      @select-all="handleSelectAllToBulkPrint"
      @select="handleSelectSingleToBulkPrint"
    >
      <el-table-column
        prop="bolNumber"
        :label="$t('customerService.billOfLading.bolNumber')"
        :min-width="6"
        align="center">
      </el-table-column>
      <el-table-column
        prop="date"
        :label="$t('customerService.billOfLading.date')"
        :min-width="5"
        align="center">
      </el-table-column>
      <el-table-column
        prop="loadNumber"
        :label="$t('customerService.billOfLading.loadNumber')"
        :min-width="7"
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.loadNumber" placement="top">
            <span>{{ scope.row.loadNumber }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="deliverTo"
        :label="$t('customerService.billOfLading.deliverTo')"
        :min-width="10"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="`${scope.row.deliverToAccountName} - ${scope.row.deliverToAccountNumber}`" placement="top">
            <span> {{ scope.row.deliverToAccountName }} - {{ scope.row.deliverToAccountNumber }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="consignee"
        :label="$t('customerService.billOfLading.consignee')"
        :min-width="10"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="`${scope.row.consigneeAccountName} - ${scope.row.consigneeAccountNumber}`" placement="top">
            <span> {{ scope.row.consigneeAccountName }} - {{ scope.row.consigneeAccountNumber }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="billTo"
        :label="$t('customerService.billOfLading.billTo')"
        :min-width="10"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="`${scope.row.billToAccountName} - ${scope.row.billToAccountNumber}`" placement="top">
            <span> {{ scope.row.billToAccountName }} - {{ scope.row.billToAccountNumber }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="shipments"
        :label="$t('customerService.billOfLading.shipments')"
        :min-width="4"
        align="center">
      </el-table-column>
      <el-table-column
        prop="units"
        :label="$t('customerService.billOfLading.units')"
        :min-width="4"
        align="center">
      </el-table-column>
      <el-table-column
        prop="cubes"
        :label="$t('customerService.billOfLading.cubes')"
        :min-width="5"
        align="center">
      </el-table-column>
      <el-table-column
        prop="manual"
        :label="$t('customerService.billOfLading.manual')"
        :min-width="3"
        align="center">
          <template slot-scope="scope">
            <i v-if="scope.row.manual" class="el-icon-success green-success"></i>
          </template>
      </el-table-column>
      <el-table-column
        v-if="!billOfLading.isInBulkPrinting"
        width="60"
        :label="$t('common.options')"
        align="center"
        class-name="fixed-width">
        <template slot-scope="scope" v-if="!billOfLading.isInBulkPrinting">
          <print-bill-of-lading v-show="scope.row.active" :bol-id="scope.row.id"/>
          <bill-of-lading-detail-dialog :currentRow="scope.row"/>
          <i class="el-icon-delete icon-action" @click="handleDeleteDetail(scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column
        v-for="i in (billOfLading.isInBulkPrinting)? [1]: []" :key="i"
        type="selection"
        align="center"
        width="70"
       />
    </el-table>
    <div class="pagination-footer" v-show="billOfLading.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('customerService.billOfLading.totalLabel') }}</span>
           {{ billOfLading.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="billOfLading.actualFilters.rows"
        :current-page.sync="billOfLading.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="billOfLading.total"
        layout="sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { Loading, Message } from 'element-ui';
import constants from '@/utils/constants';
import BillOfLadingDetailDialog from './components/BillOfLadingDetailDialog';
import PrintBillOfLading from './components/PrintBillOfLading';

export default {
  name: 'BillOfLadingSummarySection',
  components: {
    PrintBillOfLading,
    BillOfLadingDetailDialog
  },
  computed: {
    ...mapGetters(['billOfLading'])
  },
  watch: {
    'billOfLading.list': function wacthBolsList() {
      if (this.billOfLading.isInBulkPrinting) {
        const listToCheck = this.billOfLading.list.filter(bol => this.billOfLading.bulkPrintIds.includes(bol.id));
        this.$nextTick(() => {
          listToCheck.forEach(row => this.$refs.searchSummaryBillOfLadingTable.toggleRowSelection(row));
        });
      }
    },
    'billOfLading.isInBulkPrinting': function wacthBolIsInBulkPrinting() {
      this.$refs.searchSummaryBillOfLadingTable.clearSelection();
    }
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSearchChangeLimit(data) {
      this.$store.dispatch('billOfLading/search', { rows: data, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSearchChangePage(data) {
      this.$store.dispatch('billOfLading/search', { page: data });
    },
    async print(billOfLadingId) {
      const loading = Loading.service(constants.LOADING.PRINT_BILL_OF_LADING);
      await this.$store.dispatch('billOfLading/print', billOfLadingId);
      loading.close();
    },
    handleSelectAllToBulkPrint(selection) {
      this.$store.dispatch('billOfLading/toggleBulkPrintAllChecked', selection && selection.length > 0);
    },
    handleSelectSingleToBulkPrint(selection, row) {
      this.$store.dispatch('billOfLading/toggleBulkPrintSingleCheck', row.id);
    },
    async handleDeleteDetail(row) {
      const confirm = await this.$confirm(this.$t('customerService.billOfLading.deleteBolConfirmation'), { confirmButtonText: this.$t('common.yes') }).catch(() => {});
      if (confirm) {
        Message.closeAll();
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        try {
          const response = await this.$store.dispatch('billOfLading/deleteBol', {
            billOfLadingId: row.id
          });
          this.$message.success(response.message);
          this.$store.dispatch('billOfLading/search', {});
        } catch (error) {
          this.$message.error('An error occurred while trying to delete the BOL.');
        } finally {
          loading.close();
        }
      }
    }
  }
};
</script>
